import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchResultsList'

export default defineMessages({
  listboxAriaLabel: {
    id: `${scope}.listboxAriaLabel`,
    defaultMessage: 'Search results',
  },
  truncatedNotice: {
    id: `${scope}.truncatedNotice`,
    defaultMessage:
      '<strong>Showing the first 50 results.</strong> Try using a more specific keyword or {br}document ID to find exactly what you need.',
  },
})
